/*    
<summary>
   This file is used to provide initial values or state to the Device Module observables.
   Developer: Aashish Singh, Created Date: 07-April-2023
</summary>
*/

import { IGetAllDevice } from "../../models/response/IDeviceResponse";

export const initialState: IGetAllDevice = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Devices: []
}